/** Muestra la tasa vigente en la barra superior; en rojo si no hay tasa hoy. */
import { Link } from 'react-router-dom';
import { TrendingUp, AlertTriangle } from 'lucide-react';
import { useTasaStore } from '@/store/tasaStore';
import { formatearNumero } from '@/lib/formato';

export function TasaBadge() {
  const tasa = useTasaStore((s) => s.tasa);
  const cargando = useTasaStore((s) => s.cargando);

  if (cargando) {
    return <span className="text-xs text-texto-tenue">Tasa…</span>;
  }

  if (!tasa) {
    return (
      <Link
        to="/tasas-cambio"
        className="flex items-center gap-1.5 rounded-lg bg-peligro-suave px-3 py-1.5 text-sm font-medium text-peligro hover:bg-peligro-suave dark:bg-peligro-suave/40 dark:text-peligro"
      >
        <AlertTriangle className="h-4 w-4" />
        Sin tasa hoy
      </Link>
    );
  }

  return (
    <Link
      to="/tasas-cambio"
      className="flex min-h-9 shrink-0 items-center gap-1.5 rounded-md px-2 text-xs text-texto-suave hover:bg-primario-suave sm:text-sm"
      title={`Tasa del ${tasa.fecha}`}
    >
      <TrendingUp className="hidden h-3.5 w-3.5 sm:block" aria-hidden="true" />
      <span className="cifra">Bs {formatearNumero(tasa.tasa, 2)} <span className="text-texto-tenue">/ USD</span></span>
    </Link>
  );
}
